import {
    Center,
    Container,
    Stack,
    Title
} from "@mantine/core";

export const RightHandPanel = ({context}: {
    context: { greeting: string, enabled: boolean, planId: string }
}) => {

    if (context.planId) {
        return (
            <>
                <Container mt={'xl'}>
                    <Center>
                        <img src={'1024x1024_logo.png'} width={100}/>
                    </Center>
                    <Stack my={'xl'}>
                        <Title>Selected Plan: </Title>
                        {context.planId}
                    </Stack>
                </Container>
            </>
        )
    }

    return (
        <Container>
            {/*<Image src={'/1024x1024_logo.png'} radius={'md'} width={400} height={400}/>*/}
            {context.enabled && context.greeting}
        </Container>
    )

}


